import { Component } from "@angular/core";
import { ICellRendererAngularComp } from "ag-grid-angular";
import { ICellRendererParams } from "ag-grid-community";

@Component({
  selector: 'ngx-progress-bar-column',
  template: `
    <div class="d-flex justify-content-center align-items-center">
      <nb-progress-bar class="w-100 px-2" size="small" [value]="progress">{{ progressAsString }} %</nb-progress-bar>
    </div>
  `,
  styles: [`
    ::ng-deep .progress-value {
      background: linear-gradient(to right, #3C2086 10%, #57319F 70%) !important;
      transition: background 0.3s ease;
    }
  `]
})
export class ProgressBarColumnComponent implements ICellRendererAngularComp {
  public params: ICellRendererParams;
  public progress: number;
  public progressAsString: string;

  agInit(params: ICellRendererParams): void {
    this.params = params;
    this.progress = this.params.value * 100;
    this.progressAsString = this.progress.toFixed(2);
  }

  refresh(params: ICellRendererParams): boolean {
    return false;
  }
}
